import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { DefaultTheme } from './themes/DefaultTheme';
import BannerBusiness from './components/modules/BannerBusiness';
import BannerHero from './components/modules/BannerHero';
import ButtonBuyCredits from './components/modules/ButtonBuyCredits'
import ClientSelector from './components/modules/ClientSelector';
import CompareImage from './components/modules/CompareImage';
import ContactForm from './components/modules/ContactForm'
import Footer from './components/layouts/Footer';
import FeaturesGrid from './components/modules/FeaturesGrid';
import FeaturesList from './components/modules/FeaturesList';
import FeaturesListWithHelpDocs from './components/modules/FeaturesListWithHelpDocs';
import Header from './components/layouts/Header'
import Newsfeed from './components/modules/Newsfeed';
import PlnarHelp from './components/modules/PlnarHelp';
import Pricing from './components/modules/Pricing';
import Rates from './components/modules/Rates';
import SnackbarConsent from './components/modules/SnackbarConsent';
import SnackbarCookies from './components/modules/SnackbarCookies';
import Templates from './components/modules/Templates'
import Tutorials from './components/modules/Tutorials';
import ModelViewer from './components/modules/ModelViewer';

const Wrapper = (props) => {
  return (
    <React.StrictMode>
      <ThemeProvider theme={DefaultTheme}>
        {props.children}
        <CssBaseline />
      </ThemeProvider>
    </React.StrictMode>
  )
}

if (document.getElementById('banner-business')) {
  const bannerBusiness = ReactDOM.createRoot(document.getElementById('banner-business'));
  bannerBusiness.render(
    <Wrapper>
      <BannerBusiness />
    </Wrapper>
  );
}

if (document.getElementById('banner-hero')) {
  const bannerHero = ReactDOM.createRoot(document.getElementById('banner-hero'));
  bannerHero.render(
    <Wrapper>
      <BannerHero />
    </Wrapper>
  );
}

if (document.getElementById('button-buy-credits')) {
  const buttonBuyCredits = ReactDOM.createRoot(document.getElementById('button-buy-credits'));
  buttonBuyCredits.render(
    <Wrapper>
      <ButtonBuyCredits />
    </Wrapper>
  );
}

if (document.getElementById('client-selector')) {
  const clientSelector = ReactDOM.createRoot(document.getElementById('client-selector'));
  clientSelector.render(
    <Wrapper>
      <ClientSelector />
    </Wrapper>
  );
}

if (document.getElementById('compare-image')) {
  const compareImage = ReactDOM.createRoot(document.getElementById('compare-image'));
  compareImage.render(
    <Wrapper>
      <CompareImage />
    </Wrapper>
  );
}

if (document.getElementById('contact-form')) {
  const contactForm = ReactDOM.createRoot(document.getElementById('contact-form'));
  contactForm.render(
    <Wrapper>
      <ContactForm />
    </Wrapper>
  );
}

if (document.getElementById('features-grid')) {
  const featuresGrid = ReactDOM.createRoot(document.getElementById('features-grid'));
  featuresGrid.render(
    <Wrapper>
      <FeaturesGrid />
    </Wrapper>
  );
}

if (document.getElementById('features-grid-basic')) {
  const featuresGridBasic = ReactDOM.createRoot(document.getElementById('features-grid-basic'));
  featuresGridBasic.render(
    <Wrapper>
      <FeaturesGrid isPro={false} />
    </Wrapper>
  );
}

if (document.getElementById('features-grid-pro')) {
  const featuresGridPro = ReactDOM.createRoot(document.getElementById('features-grid-pro'));
  featuresGridPro.render(
    <Wrapper>
      <FeaturesGrid isPro={true} />
    </Wrapper>
  );
}

if (document.getElementById('features-list')) {
  const featuresList = ReactDOM.createRoot(document.getElementById('features-list'));
  featuresList.render(
    <Wrapper>
      <FeaturesList />
    </Wrapper>
  );
}

if (document.getElementById('features-list-with-help-docs')) {
  const featuresList = ReactDOM.createRoot(document.getElementById('features-list-with-help-docs'));
  featuresList.render(
    <Wrapper>
      <FeaturesListWithHelpDocs />
    </Wrapper>
  );
}

if (document.getElementById('features-list-basic')) {
  const featuresListBasic = ReactDOM.createRoot(document.getElementById('features-list-basic'));
  featuresListBasic.render(
    <Wrapper>
      <FeaturesList isPro={false} />
    </Wrapper>
  );
}

if (document.getElementById('features-list-pro')) {
  const featuresListPro = ReactDOM.createRoot(document.getElementById('features-list-pro'));
  featuresListPro.render(
    <Wrapper>
      <FeaturesList isPro={true} />
    </Wrapper>
  );
}

if (document.getElementById('features-list-with-help-docs-basic')) {
  const featuresListWithHelpDocsBasic = ReactDOM.createRoot(document.getElementById('features-list-with-help-docs-basic'));
  featuresListWithHelpDocsBasic.render(
    <Wrapper>
      <FeaturesListWithHelpDocs isPro={false} />
    </Wrapper>
  );
}

if (document.getElementById('features-list-with-help-docs-pro')) {
  const featuresListWithHelpDocsPro = ReactDOM.createRoot(document.getElementById('features-list-with-help-docs-pro'));
  featuresListWithHelpDocsPro.render(
    <Wrapper>
      <FeaturesListWithHelpDocs isPro={true} />
    </Wrapper>
  );
}

if (document.getElementById('footer')) {
  const footer = ReactDOM.createRoot(document.getElementById('footer'));
  footer.render(
    <Wrapper>
      <Footer />
    </Wrapper>
  );
}

if (document.getElementById('header')) {
  const header = ReactDOM.createRoot(document.getElementById('header'));
  header.render(
    <Wrapper>
      <Header />
    </Wrapper>
  );
}

if (document.getElementById('model-viewer')) {
  const modelViewer = ReactDOM.createRoot(document.getElementById('model-viewer'));
  modelViewer.render(
    <Wrapper>
      <ModelViewer />
    </Wrapper>
  );
}

if (document.getElementById('newsfeed')) {
  const newsfeed = ReactDOM.createRoot(document.getElementById('newsfeed'));
  newsfeed.render(
    <Wrapper>
      <Newsfeed />
    </Wrapper>
  );
}

if (document.getElementById('plnar-help')) {
  const plnarHelp = ReactDOM.createRoot(document.getElementById('plnar-help'));
  plnarHelp.render(
    <Wrapper>
      <PlnarHelp />
    </Wrapper>
  );
}

if (document.getElementById('pricing')) {
  const pricing = ReactDOM.createRoot(document.getElementById('pricing'));
  pricing.render(
    <Wrapper>
      <Pricing />
    </Wrapper>
  );
}

if (document.getElementById('rates')) {
  const rates = ReactDOM.createRoot(document.getElementById('rates'));
  rates.render(
    <Wrapper>
      <Rates />
    </Wrapper>
  );
}

if (document.getElementById('snackbar-consent')) {
  const snackbarConsent = ReactDOM.createRoot(document.getElementById('snackbar-consent'));
  snackbarConsent.render(
    <Wrapper>
      <SnackbarConsent />
    </Wrapper>
  );
}

if (document.getElementById('snackbar-cookies')) {
  const snackbarCookies = ReactDOM.createRoot(document.getElementById('snackbar-cookies'));
  snackbarCookies.render(
    <Wrapper>
      <SnackbarCookies />
    </Wrapper>
  );
}

if (document.getElementById('templates')) {
  const templates = ReactDOM.createRoot(document.getElementById('templates'));
  templates.render(
    <Wrapper>
      <Templates />
    </Wrapper>
  );
}

if (document.getElementById('tutorials')) {
  const tutorials = ReactDOM.createRoot(document.getElementById('tutorials'));
  tutorials.render(
    <Wrapper>
      <Tutorials />
    </Wrapper>
  );
};